module.exports = __webpack_public_path__ + "img/3_17.40ba8ed3.png";